import { PostModel } from "@/types/models/post";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "@inertiajs/react";
import Container from "../Grid/Container";
import Row from "../Grid/Row";
import Column from "../Grid/Column";

const getFormat = (filename: string) => filename.split(".").pop();

const stripHtml = (html: string) =>
    html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

const SpecialOffers = ({ posts }: { posts: PostModel[] }) => {
    if (!posts?.length) {
        return <div className="mb-14 lg:mb-26" aria-hidden="true" />;
    }

    return (
        <section id="promocje">
            <Container className="pt-[104px] mb-44">
                <h2 className="text-h2 leading-h2 text-primary font-extrabold tracking-heading uppercase mb-12">
                    Aktualne oferty specjalne
                </h2>

                <Row className="gap-y-10">
                    {posts.map((post) => (
                        <Column key={post.id} xl={4} lg={4} md={6} className="flex">
                            <article className="flex flex-col gap-8 w-full">
                                <div className="relative h-[368px] w-full overflow-hidden">
                                    <picture>
                                        <source
                                            srcSet={`${post.photo.replace(/\.[^.]+$/, "")}.webp`}
                                            type="image/webp"
                                        />
                                        <source
                                            srcSet={`${post.photo.replace(/\.[^.]+$/, "")}.${getFormat(post.photo)}`}
                                            type={`image/${getFormat(post.photo)}`}
                                        />
                                        <img
                                            src={post.photo}
                                            alt={post.name}
                                            className="absolute inset-0 size-full object-cover"
                                            loading="lazy"
                                        />
                                    </picture>

                                    <div
                                        className="absolute inset-x-0 bottom-0 h-[156px] bg-i-red flex items-end pb-5 pl-[18px] pr-4"
                                        style={{
                                            clipPath:
                                                "polygon(0 0, 100% 28%, 100% 100%, 0 100%)",
                                        }}
                                    >
                                        <div className="flex items-center gap-3">
                                            <Icon
                                                icon="lsicon:badge-promotion-outline"
                                                width={61}
                                                height={61}
                                                className="text-white shrink-0"
                                            />
                                            <p className="text-h3 leading-h3 text-white font-extrabold tracking-[0.8px]">
                                                Oferta specjalna
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col gap-3 flex-1">
                                    <h3 className="text-h3 leading-h3 text-primary font-extrabold tracking-[0.8px]">
                                        {post.name}
                                    </h3>
                                    <p className="text-p leading-p text-text tracking-p">
                                        {stripHtml(post.excerpt)}
                                    </p>
                                </div>

                                <Link
                                    href={route("frontend.promotions.single", {
                                        post: post.slug,
                                    })}
                                    className="button-primary max-w-fit"
                                >
                                    Sprawdź ofertę
                                </Link>
                            </article>
                        </Column>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default SpecialOffers;
